import {createAction, handleActions} from 'redux-actions';
import {Api} from '../../api/api';
import { logout, onForbidden } from '../account/login';
import _ from 'lodash';
import {getPendingAccreditationRequestsData} from './pendingAccreditationRequests';
import {getContinentByCountry} from '../common/location';

//- Actions
export const fetchGetPendingAccreditationRequestByIdFailed = createAction('FETCH_GET_PENDING_ACCREDITATION_REQUEST_BY_ID_FAILED');
export const fetchGetPendingAccreditationRequestByIdSuccess = createAction('FETCH_GET_PENDING_ACCREDITATION_REQUEST_BY_ID_SUCCESS');
export const fetchGetPendingAccreditationRequestById = createAction(
    'FETCH_GET_PENDING_ACCREDITATION_REQUEST_BY_ID',
    (id) => Api.getAccreditationRequestForProcessing(id),
    () => ({
        apiCall: true,
        onSuccess: fetchGetPendingAccreditationRequestByIdSuccess,
        onFail: fetchGetPendingAccreditationRequestByIdFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

//- State
const initialState = {
    data: null,
    error: null,
    fetching: false
};

//- Reducers
export default handleActions({
    FETCH_GET_PENDING_ACCREDITATION_REQUEST_BY_ID: (state) => {
        return {...state, data: null, error: null, fetching: true};
    },
    FETCH_GET_PENDING_ACCREDITATION_REQUEST_BY_ID_FAILED: (state, action) => {
        return {...state, data: null, error: action.payload, fetching: false};
    },
    FETCH_GET_PENDING_ACCREDITATION_REQUEST_BY_ID_SUCCESS: (state, action) => {
        return {...state, data: action.payload, error: null, fetching: false};
    }
}, initialState);

//- Selectors
export const getPendingAccreditationRequest = state => state.pendingAccreditationRequest;

export const loadingPendingAccreditationRequest = state => getPendingAccreditationRequest(state).fetching;

export const getPendingAccreditationRequestData = state => getPendingAccreditationRequest(state).data;

export const getPendingAccreditationRequestDataFormatted = state => {
    let data = getPendingAccreditationRequestData(state);
    let listData = getPendingAccreditationRequestsData(state);

    if (_.isNil(data) || !_.has(data, 'accreditationData.titles') || !_.has(data, 'verifiedIdentity') || _.isNil(listData)) {
        return null;
    }

    let accreditationRequestData = {
        titleOrig: data.accreditationData.titles.original,
        titleEn: data.accreditationData.titles.en,
        titlesAdditional: {},
        dateIssued: data.accreditationData.issuedAt,
        level: data.accreditationData.level,
        personFirstName: data.verifiedIdentity.firstName,
        personLastName: data.verifiedIdentity.lastName,
        personNationalId: data.verifiedIdentity.nationalId,
        personCountry: data.verifiedIdentity.countryCode,
        email: data.applicantEmail
    };

    let additionalTitles = _.pickBy((data.accreditationData.titles), (value, key) => {
        return key !== 'en' && key !== 'original';
    });

    _.mapValues(additionalTitles, (value, key) => {
        accreditationRequestData.titlesAdditional[key] = value;
    });

    //TODO: get org data from request details, but not from the list of requests
    let request = _.find(listData, request => request.id === data.id);
    if (request && _.has(request, 'organization.id')) {
        accreditationRequestData.orgId = request.organization.id;
        accreditationRequestData.orgDomain = request.organization.domain;
    }

    if (request && _.has(request, 'organization.address.countryCode')) {
        accreditationRequestData.orgCountry = request.organization.address.countryCode;
        accreditationRequestData.orgContinent = getContinentByCountry(request.organization.address.countryCode, state);
    }

    return accreditationRequestData;

};



// WEBPACK FOOTER //
// ./src/reducers/accreditation/pendingAccreditationRequest.js